<template>
    <b-alert variant="danger" :show="Object.keys(errors).length > 0" dismissible>
        <div class="mb-2">
            <strong>
                Ops! Algo deu errado.
            </strong>
        </div>

        <ul v-for="(error, key) in errors" :key="key" class="m-0 py-0 px-3">
            <li v-for="message in error" :key="message">
                {{ message }}
            </li>
        </ul>
    </b-alert>
</template>

<script>
export default {
    props: {
        errors: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
